import React, { useContext, useEffect, useState } from "react";
import Modal from "react-responsive-modal";
import { Button, Form, FormGroup, Label, Col } from "reactstrap";
// import Datepicker from 'react-datepicker';
import Select from "react-select";
import Datetime from "react-datetime";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import { Get, JENIS_DUSUN, Post } from "../../function/Koneksi";
import { generateAlamat } from '../../function/Format';
import { Tanggal } from "../../function/Format";

const ModalSuratKeteranganKelahiran = ({
  data,
  optionData,
  setAlert,
  isOpen,
  setIsOpen,
  statusRefresh,
  setStatusRefresh,
  propsData,
  kiosk
}) => {
  const dateFormat = require("dateformat");

  const frmDex = {
    uuid: "",
    id_jenis: "",
    nik_pelapor: "",
    nik: "",
    kk: "",
    nama: "",
    tempat_lahir: "",
    tanggal_lahir: "",
    jenis_kelamin: "",
    pekerjaan: "",
    pendidikan_terakhir: "",
    kewarganegaraan: "",
    agama: "",
    alamat: "",
    alamat_kk: "",
    status_perkawinan: "",
    tujuan_pembuatan: "",
    hubungan_keluarga_pelapor: "",
    hubungan_keluarga_pelapor_lainnya: "",

    //Data Ayah
    nik_ayah: "",
    nama_ayah: "",
    umur_ayah: "",
    jenis_kelamin_ayah: "",
    tempat_lahir_ayah: "",
    tanggal_lahir_ayah: "",
    kewarganegaraan_ayah: "",
    agama_ayah: "",
    pekerjaan_ayah: "",
    alamat_ayah: "",
    alamat_kk1: "",

    //Data Ibu  
    nik_ibu: "",
    nama_ibu: "",
    umur_ibu: "",
    jenis_kelamin_ibu: "",
    tempat_lahir_ibu: "",
    tanggal_lahir_ibu: "",
    kewarganegaraan_ibu: "",
    agama_ibu: "",
    pekerjaan_ibu: "",
    alamat_ibu: "",
    alamat_kk2: "",
    
    //Data Anak
    nama_anak:"",
    jenis_kelamin_anak:"",
    tanggal_lahir_anak:"",
    waktu_lahir_anak:"",
    tempat_lahir_anak:"",
    waktu_kelahiran:"",
  };

	const initFormData = {
		frmNik: optionData.frmNik,
		frmNik2: optionData.frmNik2,
		frmNik4: optionData.frmNik4,
    frmPkr: optionData.frmPkr,
		frmShdk: optionData.frmShdk,
		nikStat: null,
		nik2Stat: null,
		nik3Stat: null,
		nik4Stat: null,
		detail: [],
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
			dataPenduduk: "none",
			dataPenduduk2: "none",
			dataPenduduk3: "none",
			dataPenduduk4: "none",
      ahliWarisManual: "none",
      frmPreviewDraft: false,
		},
		formDataAyah: "none",
		formDataIbu: "none",
		formDataWali: "none",
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
    formAhliWaris: "none",
    // Preview surat
		get_data_surat:[],
		get_jenis_surat: "",
	}

  const [formData, setFormData] = useState(initFormData);
  const [props, setProps] = useState(propsData);
  const [kioskMode, setKioskMode] = useState(kiosk)
  const [dt, setDt] = useState(data ? data : frmDex);

  useEffect(() => {
    if (document.getElementById("modalForm")) {
      document.getElementById("modalForm").reset();
    }

    console.log('data useeffect')
    console.log(data)

    setDt(data ? data : frmDex);
    setFormData(
      data
        ? {
            ...initFormData,
            nikStat: optionData.nikStat,
            nik2Stat: optionData.nik2Stat,
            nik3Stat: optionData.nik3Stat,
            nik4Stat: optionData.nik4Stat,
            frmNik3: optionData.frmNik3,
            frmPkr: optionData.frmPkr,
            formDataAyah: optionData.formDataAyah,
            formDataIbu: optionData.formDataIbu,
            formDataWali: optionData.formDataWali,
            status: optionData.status,
          }
        : initFormData
    );
  }, [isOpen]);

  const handleSelectChange = (e, fld) => {
    if (e) {
      // console.log("ini handle select", dt)
      setDt({
        ...dt,
        [fld]: e
      });
    }
    else{
      setDt({
        ...dt,
        [fld]: ""
      })
    }
  };

  const handleInputChange = (e, fld) => {
    setDt({
      ...dt,
      [fld]: e.target.value
    });
  };

  const handleInputChangeNIK = (e, fld) => {
    if (e) {
      let nikStat = { value: e, label: e };

      Post("penduduk", null, { nik: e }, datanik => {
        let frmNik = [];
        datanik.data.results.data.forEach(dt => {
          frmNik.push({ value: dt.id, label: dt.id + " (" + dt.nama + ")" });
        });

        switch (fld) {
          case "nik":
            setFormData({
              ...formData,
              frmNik,
              nikStat
            });
            break;
          case "ayah":
            setFormData({
              ...formData,
              frmNik2: frmNik,
              nik2Stat: nikStat
            });
            break;
          case "wali":
            setFormData({
              ...formData,
              frmNik4: frmNik,
              nik4Stat: nikStat
            });
            break;

          default:
            break;
        }
      });
    }
  };

  const getPenduduk = (e, sel, jns) => {
    if (e) {
      if (kioskMode) {
        props.setLoadingPreview(true)
      }
      else{
        setAlert({
          loadingPreview: true
        })
      }

			Get("penduduk/find", e.value, data => {
        if(data.results){
          const alamat = generateAlamat(data.results);
          let alamat_kk = "";
      
          if(data.results.data_kk){
            alamat_kk = data.results.data_kk.alamat
          }
          // if (localStorage.getItem('JENIS_DESA').toLowerCase() === 'kelurahan') {
          //   alamat =
          //     "RT. " +
          //     data.results.data_kk.data_rt.nama +
          //     "/RW. " +
          //     data.results.data_kk.data_rt.data_rw.nama +
          //     ", " +
          //     data.results.data_kk.data_rt.data_rw.data_keldes.nama +
          //     ", Kec. " +
          //     data.results.data_kk.data_rt.data_rw.data_keldes
          //       .data_kecamatan.nama +
          //     ", " +
          //     data.results.data_kk.data_rt.data_rw.data_keldes
          //       .data_kecamatan.data_kabkota.nama;
          // } else {
          //   if (data.results.data_kk.id_rt === '0') {
          //     alamat = localStorage.getItem('JENIS_DESA') + " " + data.results.data_keldes.nama +
          //       ", Kec. " + data.results.data_keldes.data_kecamatan.nama +
          //       ", " + data.results.data_keldes.data_kecamatan.data_kabkota.nama +
          //       ", " + data.results.data_keldes.data_kecamatan.data_kabkota.data_provinsi.nama;
          //   } else {
          //     if(
          //       data.results.data_kk.data_rt && 
          //       data.results.data_kk.data_rt.data_rw &&
          //       data.results.data_kk.data_rt.data_rw.data_dusun &&
          //       data.results.data_kk.data_rt.data_rw.data_dusun.data_keldes &&
          //       data.results.data_kk.data_rt.data_rw.data_dusun.data_keldes.data_kecamatan &&
          //       data.results.data_kk.data_rt.data_rw.data_dusun.data_keldes.data_kecamatan.data_kabkota
          //     ){
          //       alamat =
          //         " RT. " +
          //         data.results.data_kk.data_rt.nama +
          //         "/RW. " +
          //         data.results.data_kk.data_rt.data_rw.nama +
          //         ", " + JENIS_DUSUN + " " +
          //         data.results.data_kk.data_rt.data_rw.data_dusun.nama +
          //         ", " + localStorage.getItem('JENIS_DESA') + " " +
          //         data.results.data_kk.data_rt.data_rw.data_dusun.data_keldes.nama +
          //         ", Kec. " +
          //         data.results.data_kk.data_rt.data_rw.data_dusun.data_keldes
          //           .data_kecamatan.nama +
          //         ", " +
          //         data.results.data_kk.data_rt.data_rw.data_dusun.data_keldes
          //           .data_kecamatan.data_kabkota.nama;
          //     }
          //     else{
          //       setAlert({
          //         loadingPreview: false
          //       })

          //       const alertData = {
          //         show: true,
          //         basicType: "info",
          //         basicTitle: "Data Penduduk Tidak Lengkap",
          //         pesanAlert: "Mohon Perbaiki Data Kependudukan Terlebih Dahulu"
          //       }
          //       setAlert(alertData)
          //     }
          //   }
          // }

          if (jns === "pelapor") {
              console.log('data pdd')
              console.log(e)
              setFormData({
                ...formData,
                formDataAyah:"block",
                nikStat: e,
                status: {
                  ...formData.status,
                  dataPenduduk: "block",
                },
              });
              setDt({
                ...dt,
                nik: e.value,
                nik_pelapor: e.value,
                kk: data.results.id_kk,
                nama: data.results.nama,
                nama_pemohon: data.results.nama,
                tempat_lahir: data.results.tempat_lahir,
                tanggal_lahir: new Date(data.results.tanggal_lahir),
                pekerjaan: data.results.data_pekerjaan.nama,
                pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
                agama: data.results.data_agama.nama,
                status_perkawinan: data.results.status_perkawinan,
                jenis_kelamin: data.results.jk,
                alamat: alamat,
                alamat_kk: alamat_kk,
                kewarganegaraan: "WNI",
                detail: []
              });
              
              if (kioskMode) {
                props.setLoadingPreview(false)
              }
              else{
                setAlert({
                  loadingPreview: false
                })
              }

              // For testing
              // if (props.selectOnChange2) {
              // 	props.selectOnChange2(dt)
              // }

          } else if (jns === "ayah") {
            Get("penduduk/kk/" + data.results.id_kk, null, dtkk => {
              let frmNik3 = [];
              dtkk.results.forEach(val => {
                frmNik3.push({
                  value: val.id,
                  label: val.id + " (" + val.nama + ")"
                });
              });

              setFormData({
                ...formData,
                nik2Stat: e,
                frmNik3:frmNik3,
                status: {
                  ...formData.status,
                  dataPenduduk2: "block",
                },
                formDataAyah:'block',
                formDataIbu:'block',
                formDataWali:'block',
              })
              
              setDt({
                ...dt,
                nik_ayah: e.value,
                nama_ayah: data.results.nama,
                jenis_kelamin_ayah: data.results.jk,
                tempat_lahir_ayah: data.results.tempat_lahir,
                tanggal_lahir_ayah: new Date(
                  data.results.tanggal_lahir
                ),
                agama_ayah: data.results.data_agama.nama,
                pekerjaan_ayah: data.results.data_pekerjaan.nama,
                pendidikan_terakhir_ayah: data.results.data_pendidikan_terakhir.nama,
                status_perkawinan_ayah: data.results.status_perkawinan,
                alamat_ayah: alamat,
                alamat_kk1: alamat_kk,
              })
              
              if (kioskMode) {
                props.setLoadingPreview(false)
              }
              else{
                setAlert({
                  loadingPreview: false
                })
              }

              // For testing
              // if (props.selectOnChange2) {
              // 	props.selectOnChange2(dt)
              // }

            });

            // =====

            if (kioskMode) {
              props.setLoadingPreview(false)
            }
            else{
              setAlert({
                loadingPreview: false
              })
            }
          } else if (jns === "ibu") {
            setFormData({
              ...formData,
              nik3Stat: e,
              status: {
                ...formData.status,
                dataPenduduk3: "block",
              },
            })
            setDt({
              ...dt,
              nik_ibu: e.value,
              nama_ibu: data.results.nama,
              jenis_kelamin_ibu: data.results.jk,
              tempat_lahir_ibu: data.results.tempat_lahir,
              tanggal_lahir_ibu: new Date(
                data.results.tanggal_lahir
              ),
              agama_ibu: data.results.data_agama.nama,
              pekerjaan_ibu: data.results.data_pekerjaan.nama,
              pendidikan_terakhir_ibu: data.results.data_pendidikan_terakhir.nama,
              status_perkawinan_ibu: data.results.status_perkawinan,
              alamat_ibu: alamat,
              alamat_kk2: alamat_kk,
            })
            
            if (kioskMode) {
              props.setLoadingPreview(false)
            }
            else{
              setAlert({
                loadingPreview: false
              })
            }
          } else if (jns === "wali") {
            setFormData({
              ...formData,
              nik4Stat: e,
              status: {
                ...formData.status,
                dataPenduduk4: "block",
              },
            })
            setDt({
              ...dt,
              nik_wali: e.value,
              nama_wali: data.results.nama,
              jenis_kelamin_wali: data.results.jk,
              tempat_lahir_wali: data.results.tempat_lahir,
              tanggal_lahir_wali: new Date(
                data.results.tanggal_lahir
              ),
              agama_wali: data.results.data_agama.nama,
              pekerjaan_wali: data.results.data_pekerjaan.nama,
              pendidikan_terakhir_wali: data.results.data_pendidikan_terakhir.nama,
              status_perkawinan_wali: data.results.status_perkawinan,
              alamat_wali: alamat,
              alamat_kk3: alamat_kk,
            })
            
            if (kioskMode) {
              props.setLoadingPreview(false)
            }
            else{
              setAlert({
                loadingPreview: false
              })
            }
          }
        }
        else{
          if (kioskMode) {
            props.setLoadingPreview(true)
          }
          else{
            setAlert({
              loadingPreview: true
            })
          }
        }
      });
    } else {
      switch (jns) {
        case "pelapor":
          Get("penduduk", null, data => {
            let frmNik = [];
            data.results.data.forEach(dt => {
              frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
            });

            setDt({
              ...dt,
              //Data Ayah
              nik_ayah: "",
              nama_ayah: "",
              jenis_kelamin_ayah: "",
              tempat_lahir_ayah: "",
              tanggal_lahir_ayah: "",
              kewarganegaraan_ayah: "",
              agama_ayah: "",
              pekerjaan_ayah: "",
              alamat_ayah: "",
              alamat_kk1: "",
  
              //Data Ibu  
              nik_ibu: "",
              nama_ibu: "",
              jenis_kelamin_ibu: "",
              tempat_lahir_ibu: "",
              tanggal_lahir_ibu: "",
              kewarganegaraan_ibu: "",
              agama_ibu: "",
              pekerjaan_ibu: "",
              alamat_ibu: "",
              alamat_kk2: "",
              
              //Data Wali
              nik_wali: "",
              nama_wali: "",
              jenis_kelamin_wali: "",
              tempat_lahir_wali: "",
              tanggal_lahir_wali: "",
              kewarganegaraan_wali: "",
              agama_wali: "",
              pekerjaan_wali: "",
              alamat_wali: "",
              alamat_kk3: "",
              
              //Data Saksi
              nama_saksi: "",
              nama_saksi2: "",
              
              //Data Anak
              nama_anak:"",
              anak_ke:"",
              jumlah_saudara:"",
            })
            setFormData({
              ...formData,
              status: {
                ...formData.status,
                dataPenduduk: "none",
                dataPenduduk2:"none",
                dataPenduduk3:"none",
                dataPenduduk4:"none",
              },
              formDataAyah:"none",
              formDataIbu:"none",
              formDataWali:"none",
              nikStat: null,
              nik2Stat: null,
              nik3Stat: null,
              nik4Stat: null,
              frmNik: frmNik,
              frmNik2: frmNik,
              frmNik3: [],
              frmNik4: frmNik,
            });
          })
          
          break;
        case "ayah":
          Get("penduduk", null, data => {
            let frmNik = [];
            data.results.data.forEach(dt => {
              frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
            });

            setDt({
              ...dt,
              //Data Ayah
              nik_ayah: "",
              nama_ayah: "",
              jenis_kelamin_ayah: "",
              tempat_lahir_ayah: "",
              tanggal_lahir_ayah: "",
              kewarganegaraan_ayah: "",
              agama_ayah: "",
              pekerjaan_ayah: "",
              alamat_ayah: "",
              alamat_kk1: "",
  
              //Data Ibu  
              nik_ibu: "",
              nama_ibu: "",
              jenis_kelamin_ibu: "",
              tempat_lahir_ibu: "",
              tanggal_lahir_ibu: "",
              kewarganegaraan_ibu: "",
              agama_ibu: "",
              pekerjaan_ibu: "",
              alamat_ibu: "",
              alamat_kk2: "",
              
              //Data Wali
              nik_wali: "",
              nama_wali: "",
              jenis_kelamin_wali: "",
              tempat_lahir_wali: "",
              tanggal_lahir_wali: "",
              kewarganegaraan_wali: "",
              agama_wali: "",
              pekerjaan_wali: "",
              alamat_wali: "",
              alamat_kk3: "",
            });
            setFormData({
              ...formData,
              frmNik2: frmNik,
              frmNik4: frmNik,
              status: {
                ...formData.status,
                dataPenduduk2: "none",
                dataPenduduk3: "none",
                dataPenduduk4: "none",
              },
              formDataIbu:'none',
              formDataWali:'none',
              nik2Stat: null,
              nik3Stat: null,
              nik4Stat: null,
            });
      
          });
          break;
        case "ibu":
          setDt({
            ...dt,
            //Data Ibu  
            nik_ibu: "",
            nama_ibu: "",
            jenis_kelamin_ibu: "",
            tempat_lahir_ibu: "",
            tanggal_lahir_ibu: "",
            kewarganegaraan_ibu: "",
            agama_ibu: "",
            pekerjaan_ibu: "",
            alamat_ibu: "",
            alamat_kk2: "",
          });
          setFormData({
            ...formData,
            status: {
              ...formData.status,
              dataPenduduk3: "none"
            },
            nik3Stat: null,
          });
          break;
        case "wali":
          Get("penduduk", null, data => {
            let frmNik = [];
            data.results.data.forEach(dt => {
              frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
            });

            setDt({
              ...dt,
              //Data Waris
              nik_wali: "",
              nama_wali: "",
              jenis_kelamin_wali: "",
              tempat_lahir_wali: "",
              tanggal_lahir_wali: "",
              kewarganegaraan_wali: "",
              agama_wali: "",
              pekerjaan_wali: "",
              alamat_wali: "",
              alamat_kk3: "",
            });
            setFormData({
              ...formData,
              status: {
                ...formData.status,
                dataPenduduk4: "none"
              },
              frmNik4:frmNik,
              nik4Stat: null,
            });
          })
          break;
        default:
          break;
      }
    }
  };

  const gantiTgl = (date, fld) => {
		switch (fld) {
		  case "waktu_lahir":
			if (typeof date._isValid !== 'undefined') {
			  let tgl = date.format('YYYY-MM-DD HH:mm:ss');
        let ex_tgl = tgl.split(" ");
        let tgl_lahir = ex_tgl[0]
        let jam_lahir = ex_tgl[1]

        setDt({
          ...dt,
          tanggal_lahir_anak: tgl_lahir,
          waktu_lahir_anak: jam_lahir,
          waktu_kelahiran: new Date(tgl)
        })
			}
			break;

		  default:
			// no default
			break;
		}
	};

  const simpan = e => {
    e.preventDefault();

    if (kioskMode){
      props.setLoadingPreview(true)
    }
    else{
      setAlert({
        loadingPreview: true
      })
    }

    let shdk_pelapor = "";

    let validasiPelapor = false
    let validasiAnak = false

    if(formData.nikStat && dt.hubungan_keluarga_pelapor){
      if(dt.hubungan_keluarga_pelapor.label === "Lainnya" || dt.hubungan_keluarga_pelapor.label === "Famili Lain"){
        if(dt.hubungan_keluarga_pelapor_lainnya){
          validasiPelapor = true
          shdk_pelapor = dt.hubungan_keluarga_pelapor_lainnya
        }
      }
      else{
        validasiPelapor = true
        shdk_pelapor = dt.hubungan_keluarga_pelapor.label
      }
    }

    if(dt.jenis_kelamin_anak && dt.waktu_kelahiran){
      validasiAnak = true
    }

    if (validasiPelapor && validasiAnak && formData.nik2Stat && formData.nik3Stat) {

      let bodyRaw = {
        ...dt,
        tanggal_lahir: dateFormat(new Date(dt.tanggal_lahir), "yyyy-mm-dd"),
        kewarganegaraan: 'Indonesia',
        tujuan_pembuatan: '-',
      };

      let dataAyah = {
        nik_ayah: dt.nik_ayah,
        nama_ayah: dt.nama_ayah,
        umur: dt.umur_ayah,
        jenis_kelamin: dt.jenis_kelamin_ayah,
        tempat_lahir: dt.tempat_lahir_ayah,
        tanggal_lahir: dateFormat(new Date(dt.tanggal_lahir_ayah),"yyyy-mm-dd"),
        kewarganegaraan: 'Indonesia',
        agama: dt.agama_ayah,
        pekerjaan: dt.pekerjaan_ayah,
        alamat: dt.alamat_ayah,
        alamat_kk: dt.alamat_kk1,
      }

      let dataIbu = {
        nik_ibu: dt.nik_ibu,
        nama_ibu: dt.nama_ibu,
        umur: dt.umur_ibu,
        jenis_kelamin: dt.jenis_kelamin_ibu,
        tempat_lahir: dt.tempat_lahir_ibu,
        tanggal_lahir: dateFormat(new Date(dt.tanggal_lahir_ibu),"yyyy-mm-dd"),
        kewarganegaraan: 'Indonesia',
        agama: dt.agama_ibu,
        pekerjaan: dt.pekerjaan_ibu,
        alamat: dt.alamat_ibu,
        alamat_kk: dt.alamat_kk2,
      }
      
      let dataAnak = {
        nama_anak: dt.nama_anak,
        jenis_kelamin: dt.jenis_kelamin_anak.value,
        tanggal_lahir: dt.tanggal_lahir_anak,
        waktu_lahir: dt.waktu_lahir_anak,
        tempat_lahir: dt.tempat_lahir_anak,
        waktu_kelahiran: dateFormat(dt.waktu_kelahiran, 'yyyy-mm-dd HH:MM:ss'),
      }

      let detail_surat = {
        shdk: shdk_pelapor,
        shdk_stat: dt.hubungan_keluarga_pelapor,
        data_anak: dataAnak,
        data_ayah: dataAyah,
        data_ibu: dataIbu,
      };

      // Set Detail Surat pada BodyRaw
      bodyRaw = {
        ...bodyRaw,
        detail_surat: JSON.stringify(detail_surat),
      }

      if (dt.uuid === "") {
        if (kioskMode) {
					bodyRaw.id_jenis = props.id_jenis
				} else {
					bodyRaw.id_jenis = props.location.state.uuid
				}
      }
      console.log(bodyRaw);

      let psn = "";
      let resstat = 204;
      let metode = "create";
      if (bodyRaw.uuid === "") {
        psn = "Tambah";
        resstat = 201;
        bodyRaw.uuid = null;
      } else {
        psn = "Ubah";
        resstat = 200;
        metode = "update";
      }
      
      Post(
				"surat-keterangan/grup/" + metode,
				bodyRaw.uuid,
				bodyRaw,
				res => {
          // For testing
          if (props.resSubmit) {
            props.resSubmit(res.status);
          }
          // this.tutupForm();
          setFormData({
            ...formData,
            status: {
              ...formData.status,
              btnForm: false,
              form: false
            }
          });
          setIsOpen(false);

          if (kioskMode) {
            if (res.status === resstat) {
              let dataAntrian = {
                nama: props.data.results.nama,
                nik: props.data.results.id,
                keterangan: '',
                uuid_surat:res.data.results.uuid_surat,
                kode_surat:res.data.results.kode_surat,
              };
  
              // Set Data Surat
              props.getDataSurat(res.data.results);

              setTimeout(function () {
                Get('persetujuan/kiosk/' + dataAntrian.uuid_surat + '/' + props.id_jenis, null, (res2) => {
                  
                  props.setLoadingPreview(false)

                  if (res2.code === 201) {
                    props.getAntrian('Surat Keterangan Kelahiran V2', 'berhasil', false, dataAntrian);
                  }
                  else {
                    props.getAntrian('Surat Keterangan Kelahiran V2', 'gagal');
                  }
                });
              }.bind(this),1000)
            }
            else{
              props.setLoadingPreview(false)
              props.getAntrian('Surat Keterangan Kelahiran V2', 'gagal');
            }

					} else {
            if (res.status === resstat) {
              const alertData = {
                get_data_surat:{
                  uuid_surat:res.data.results.uuid_surat,
                  kode_surat:res.data.results.kode_surat,
                },
                status:{
                  frmPreviewDraft: true,
                  jenis_form: psn,
                }
                // show: true,
                // basicType: "success",
                // basicTitle: "Data Surat Keterangan Kelahiran",
                // pesanAlert: "Berhasil " + psn + " Data",
                // successAlert: true
              };
              setAlert({
                loadingPreview: false
              })
              setAlert(alertData);
            } else {
              const alertData = {
                show: true,
                basicType: "danger",
                basicTitle: "Data Surat Keterangan Kelahiran",
                pesanAlert: "Gagal " + psn + " Data"
              };
              setAlert({
                loadingPreview: false
              })
              setAlert(alertData);
            }
            // Refresh list
            setStatusRefresh(true);
          }
        }
      );
    } else {
      if (kioskMode){
				props.getAntrian('Surat Keterangan Kelahiran V2', 'gagal', true);
				props.setLoadingPreview(false)
			}
			else{
				const alertData = {
					show: true,
					basicType: "info",
					basicTitle: "Data Belum Lengkap",
					pesanAlert: "Mohon isi seluruh data dengan benar"
				}
        setAlert({
          loadingPreview: false
        })
				setAlert(alertData)
			}
    }
  };
  
  return (
    <Modal
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      style={{
        maxwidth: "unset"
      }}
      styles={{
      	// modal: {
      		width: '100%',
      		// minWidth: '301px'
      	// }
      }}
    >
      <Form data-testid="form-create" className="theme-form" onSubmit={simpan}>
        <div className="modal-header">
          <h5 className="modal-title">
            {dt.uuid == "" ? "Tambah" : "Edit"} Surat Keterangan Kelahiran
          </h5>
        </div>
        <div className="modal-body">
          <p>
            Data identitas akan terisi secara otomatis saat NIK dipilih. Jika
            ada ketidak sesuaian data, silakan ubah di data master penduduk.
          </p>
          <input
            className="form-control"
            id="uuid"
            type="hidden"
            placeholder=""
            defaultValue={dt.uuid}
          />
          <FormGroup className="row">
            <Col sm="12">
              <Label className="col-form-label" htmlFor="nik">
                <b>NIK Penduduk</b>
              </Label>
              <div data-testid="selectNIK">
                <Select
                  inputId="nik"
                  classNamePrefix="select"
                  onChange={e => {
                    getPenduduk(e, "nik", "pelapor");
                  }}
                  defaultValue={formData.nikStat}
                  value={formData.nikStat}
                  name="NIK"
                  options={formData.frmNik}
                  placeholder="Pilih NIK"
                  onInputChange={e => handleInputChangeNIK(e, "nik")}
                  isClearable
                />
              </div>
            </Col>
          </FormGroup>
          <div style={{ display: formData.status.dataPenduduk }}>
            <FormGroup className="row">
              <Col sm="12">
                <Label className="col-form-label" htmlFor="inputEmail3">
                  <b>Nama Penduduk</b>
                </Label>
                <input
                  className="form-control"
                  id="nama"
                  type="text"
                  placeholder="Nama Pemohon"
                  value={dt.nama}
                  readOnly
                  style={{ backgroundColor: "#c9d1d8" }}
                  disabled
                />
              </Col>
            </FormGroup>
            <FormGroup className="row">
              <Col sm="12">
                <Label className=" col-form-label" htmlFor="inputEmail3">
                  <b>Tempat Lahir</b>
                </Label>
                <input
                  className="form-control"
                  id="tempat_lahir"
                  type="text"
                  placeholder="Tempat Lahir"
                  value={dt.tempat_lahir}
                  readOnly
                  style={{ backgroundColor: "#c9d1d8" }}
                  disabled
                />
              </Col>
            </FormGroup>
            <FormGroup className="row">
              <Col sm="12">
                <Label className="col-form-label" htmlFor="inputEmail3">
                  <b>Tanggal Lahir</b>
                </Label>
                <input
                  className="form-control"
                  id="tanggal_lahir"
                  type="text"
                  placeholder="Tanggal Lahir"
                  value={new Date(dt.tanggal_lahir).toLocaleDateString("id-ID")}
                  readOnly
                  style={{ backgroundColor: "#c9d1d8" }}
                  disabled
                />
              </Col>
            </FormGroup>
            <FormGroup className="row">
              <Col sm="12">
                <Label className=" col-form-label" htmlFor="inputEmail3">
                  <b>Alamat</b>
                </Label>
                <input
                  className="form-control"
                  id="alamat_kk"
                  type="text"
                  placeholder="Alamat"
                  value={dt.alamat_kk}
                  readOnly
                  style={{ backgroundColor: "#c9d1d8" }}
                  disabled
                />
              </Col>
            </FormGroup>
            <FormGroup className="row">
              <Col sm="12">
                <Label className=" col-form-label" htmlFor="inputEmail3">
                  <b>Wilayah</b>
                </Label>
                <input
                  className="form-control"
                  id="alamat"
                  type="text"
                  placeholder=""
                  value={dt.alamat}
                  readOnly
                  style={{ backgroundColor: "#c9d1d8" }}
                  disabled
                />
                <small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
              </Col>
            </FormGroup>
            <FormGroup className="row">
              <Col sm="12">
                <Label className=" col-form-label" htmlFor="inputEmail3">
                  <b>Hubungan Keluarga</b>
                </Label>
                <Select
                  inputId="hubungan_keluarga_pelapor"
                  classNamePrefix="select"
                  name="hubungan_keluarga_pelapor"
                  id="hubungan_keluarga_pelapor"
                  required={
                    formData.status.dataPenduduk === "none" ? false : true
                  }
                  value={dt.hubungan_keluarga_pelapor}
                  options={formData.frmShdk}
                  onChange={e => handleSelectChange(e, "hubungan_keluarga_pelapor")}
                  placeholder="Pilih Hubungan Keluarga"
                  isClearable
                />
              </Col>
            </FormGroup>
            <div style={{ display: dt.hubungan_keluarga_pelapor && dt.hubungan_keluarga_pelapor.label === "Lainnya" || dt.hubungan_keluarga_pelapor.label === "Famili Lain"?'block':'none' }}>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Hubungan Keluarga Lainnya</b>
                  </Label>
                  <input
                    data-testid="hubungan_keluarga_pelapor_lainnya"
                    name="hubungan_keluarga_pelapor_lainnya"
                    className="form-control"
                    id="hubungan_keluarga_pelapor_lainnya"
                    type="text"
                    placeholder="Hubungan Keluarga Lainnya"
                    defaultValue={dt.hubungan_keluarga_pelapor_lainnya}
                    required={
                      dt.hubungan_keluarga_pelapor && dt.hubungan_keluarga_pelapor.label === "Lainnya" || dt.hubungan_keluarga_pelapor.label === "Famili Lain" ? true : false
                    }
                    onChange={e => handleInputChange(e, "hubungan_keluarga_pelapor_lainnya")}
                  />
                </Col>
              </FormGroup>
            </div>
          </div>
          <div style={{ display: formData.formDataAyah }}>
            <div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
							<b>Data Ayah</b>
						</div>
            <FormGroup className="row">
              <Col sm="12">
                <Label className="] col-form-label" htmlFor="nik2">
                  <b>NIK</b>
                </Label>
                <div data-testid="selectNIK2">
                  <Select
                    inputId="nik2"
                    classNamePrefix="select"
                    onChange={e => {
                      getPenduduk(e, "nik", "ayah");
                    }}
                    defaultValue={formData.nik2Stat}
                    value={formData.nik2Stat}
                    name="NIK2"
                    options={formData.frmNik2}
                    placeholder="Pilih NIK"
                    onInputChange={e => handleInputChangeNIK(e, "ayah")}
                    isClearable
                  />
                </div>
              </Col>
            </FormGroup>
            <div style={{ display: formData.status.dataPenduduk2 }}>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Nama</b>
                  </Label>
                  <input
                    className="form-control"
                    id="nama_ayah"
                    type="text"
                    placeholder="Nama Ayah"
                    value={dt.nama_ayah}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Agama</b>
                  </Label>
                  <input
                    className="form-control"
                    id="agama_ayah"
                    type="text"
                    placeholder="Agama"
                    value={dt.agama_ayah}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Pekerjaan</b>
                  </Label>
                  <input
                    className="form-control"
                    id="pekerjaan_ayah"
                    type="text"
                    placeholder="Pekerjaan"
                    value={dt.pekerjaan_ayah}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Alamat</b>
                  </Label>
                  <input
                    className="form-control"
                    id="alamat_kk1"
                    type="text"
                    placeholder="Alamat Ayah"
                    value={dt.alamat_kk1}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Wilayah</b>
                  </Label>
                  <input
                    className="form-control"
                    id="alamat_ayah"
                    type="text"
                    placeholder=""
                    value={dt.alamat_ayah}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                  <small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Umur</b>
                  </Label>
                  <input
                    data-testid="umur_ayah"
                    name="umur_ayah"
                    className="form-control"
                    id="umur_ayah"
                    type="text"
                    placeholder="Umur Ayah"
                    defaultValue={dt.umur_ayah}
                    required={
                      formData.status.dataPenduduk2 !== "none" ? true : false
                    }
                    pattern="\d{1,16}"
                    minLength={2}
                    maxLength={2}
                    onChange={e => handleInputChange(e, "umur_ayah")}
                  />
                </Col>
              </FormGroup>
            </div>
          </div>
          <div style={{ display: formData.formDataIbu }}>
            <div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
							<b>Data Ibu</b>
						</div>
            <FormGroup className="row">
              <Col sm="12">
                <Label className="] col-form-label" htmlFor="nik3">
                  <b>NIK</b>
                </Label>
                <div data-testid="selectNIK2">
                  <Select
                    inputId="nik3"
                    classNamePrefix="select"
                    onChange={e => {
                      getPenduduk(e, "nik", "ibu");
                    }}
                    defaultValue={formData.nik3Stat}
                    value={formData.nik3Stat}
                    name="NIK2"
                    options={formData.frmNik3}
                    placeholder="Pilih NIK"
                    // onInputChange={e => handleInputChangeNIK(e, "nik2")}
                    isClearable
                  />
                </div>
              </Col>
            </FormGroup>
            <div style={{ display: formData.status.dataPenduduk3 }}>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Nama</b>
                  </Label>
                  <input
                    className="form-control"
                    id="nama_ibu"
                    type="text"
                    placeholder="Nama Ibu"
                    value={dt.nama_ibu}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Agama</b>
                  </Label>
                  <input
                    className="form-control"
                    id="agama_ibu"
                    type="text"
                    placeholder="Agama"
                    value={dt.agama_ibu}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Pekerjaan</b>
                  </Label>
                  <input
                    className="form-control"
                    id="pekerjaan_ibu"
                    type="text"
                    placeholder="Pekerjaan"
                    value={dt.pekerjaan_ibu}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Alamat</b>
                  </Label>
                  <input
                    className="form-control"
                    id="alamat_kk2"
                    type="text"
                    placeholder="Alamat Ibu"
                    value={dt.alamat_kk2}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Wilayah</b>
                  </Label>
                  <input
                    className="form-control"
                    id="alamat_ibu"
                    type="text"
                    placeholder=""
                    value={dt.alamat_ibu}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                  <small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Umur</b>
                  </Label>
                  <input
                    data-testid="umur_ibu"
                    name="umur_ibu"
                    className="form-control"
                    id="umur_ibu"
                    type="text"
                    placeholder="Umur Ibu"
                    defaultValue={dt.umur_ibu}
                    required={
                      formData.status.dataPenduduk3 !== "none" ? true : false
                    }
                    pattern="\d{1,16}"
                    minLength={2}
                    maxLength={2}
                    onChange={e => handleInputChange(e, "umur_ibu")}
                  />
                </Col>
              </FormGroup>
            </div>
          </div>

          <div style={{ display: formData.status.dataPenduduk2 }}>
            <div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
                <b>Data Anak</b>
            </div>
            <FormGroup className="row">
              <Col sm="12">
                <Label className="col-form-label" htmlFor="inputEmail3">
                  <b>Nama</b>
                </Label>
                <input
                  data-testid="nama anak"
                  name="nama_anak"
                  className="form-control"
                  id="nama_anak"
                  type="text"
                  placeholder="Nama Anak"
                  defaultValue={dt.nama_anak}
                  required={
                    formData.status.dataPenduduk2 !== "none" ? true : false
                  }
                  onChange={e => handleInputChange(e, "nama_anak")}
                />
              </Col>
            </FormGroup>
            <FormGroup className="row">
              <Col sm="12">
                <Label className="col-form-label" htmlFor="inputEmail3">
                  <b>Jenis Kelamin</b>
                </Label>
                <Select
                  inputId="jenis_kelamin_anak"
                  data-testid="jenis_kelamin_anak"
                  name="jenis_kelamin_anak"
                  id="jenis_kelamin_anak"
                  required={
                    formData.status.dataPenduduk2 === "none" ? false : true
                  }
                  placeholder="Pilih Jenis Kelamin"
                  // defaultValue={dt.jk_ahli_waris}
                  value={dt.jenis_kelamin_anak}
                  options={[
                    { label: "Laki-Laki", value: "Laki-Laki" },
                    { label: "Perempuan", value: "Perempuan" }
                  ]}
                  onChange={e => handleSelectChange(e, "jenis_kelamin_anak")}
                />
              </Col>
            </FormGroup>
            <FormGroup className="row">
              <Col sm="12">
                <Label className="col-form-label" htmlFor="inputEmail3">
                  <b>Waktu Lahir</b>
                </Label>
                <Datetime
                  inputProps={{ "data-testid": "waktu_lahir", placeholder: 'Waktu Lahir', required: true }}
                  inputId="waktu_lahir"
                  name="waktu_lahir"
                  locale="id-ID"
                  timeFormat={"HH:mm"}
                  dateFormat="DD/MM/yyyy"
                  input={false}
                  closeOnSelect={false}
                  initialValue={dt.waktu_kelahiran}
                  value={dt.waktu_kelahiran}
                  onChange={e => {
                    gantiTgl(e, 'waktu_lahir')
                  }}
                />
              </Col>
            </FormGroup>
            <FormGroup className="row">
              <Col sm="12">
                <Label className="col-form-label" htmlFor="inputEmail3">
                  <b>Tempat Lahir</b>
                </Label>
                <input
                  data-testid="tempat_lahir"
                  name="tempat_lahir"
                  className="form-control"
                  id="tempat_lahir"
                  type="text"
                  placeholder="Tempat Lahir"
                  defaultValue={dt.tempat_lahir_anak}
                  required={
                    formData.status.dataPenduduk2 !== "none" ? true : false
                  }
                  onChange={e => handleInputChange(e, "tempat_lahir_anak")}
                />
              </Col>
            </FormGroup>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-warning"
            onClick={() => {
              // Tutup modal
              setFormData({
                ...formData,
                status: {
                  ...formData.status,
                  form: false,
                  frmPreviewDraft: false,
									jenis_form: '',
                }
              });
              setIsOpen(false);
            }}
          >
            Tutup
          </button>
          <button
            data-testid="btnSubmitCreate"
            type="submit"
            className="btn btn-primary-custom"
            // disabled={formData.status.btnForm}
          >
            Simpan
          </button>
        </div>
      </Form>
    </Modal>
  );
};

export default ModalSuratKeteranganKelahiran;
